import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { KeyRound, X, Info } from "lucide-react";
import { toast } from "sonner";
import { Btn } from "./ui";

export default function ApiKeyModal({ open, onClose }) {
  // Never persist inference keys in the browser: the Aegis plane is keyed server-side.
  const [key, setKey] = useState("");

  const save = () => {
    setKey("");
    toast.message(
      key.trim()
        ? "Key accepted for this session only · never written to browser storage"
        : "Using built-in Aegis inference plane (Gemini 3 Pro)"
    );
    onClose();
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[60] grid place-items-center glass px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="apikey-modal"
        >
          <motion.div
            initial={{ scale: 0.94, y: 12, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ type: "spring", stiffness: 320, damping: 26 }}
            className="w-full max-w-md rounded-2xl border border-aegis-purple/30 bg-panel shadow-2xl"
          >
            <div className="flex items-center justify-between px-6 py-4 border-b border-edge">
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-9 w-9 rounded-lg border border-aegis-purple/40 bg-aegis-purple/10 text-aegis-purple">
                  <KeyRound size={18} />
                </span>
                <div>
                  <h3 className="font-heading text-[15px] font-medium text-slate-100">Inference Engine Key</h3>
                  <p className="text-[11px] text-slate-400">配置云端推理引擎 (可选)</p>
                </div>
              </div>
              <button onClick={onClose} className="text-slate-400 hover:text-slate-100 transition-colors" data-testid="apikey-close-btn">
                <X size={18} />
              </button>
            </div>
            <div className="p-6 space-y-4">
              <div>
                <label className="text-[10px] uppercase tracking-overline text-slate-400">Gemini API Key</label>
                <input
                  data-testid="apikey-input"
                  type="password"
                  value={key}
                  onChange={(e) => setKey(e.target.value)}
                  placeholder="AIza… (leave empty to use built-in plane)"
                  className="mt-1.5 w-full rounded-lg border border-edge well px-3 py-2.5 font-mono text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500 focus:border-slate-600"
                />
              </div>
              <div className="flex gap-2 rounded-lg border border-edge raise p-3 text-[11px] text-slate-400">
                <Info size={14} className="text-aegis-cyan shrink-0 mt-0.5" />
                <span>
                  Copilot &amp; Forensics run on the built-in Aegis plane (Gemini 3 Pro) by default. A personal key is optional and
                  never leaves this browser.
                </span>
              </div>
            </div>
            <div className="flex justify-end gap-2 px-6 py-4 border-t border-edge">
              <Btn variant="ghost" onClick={onClose}>取消</Btn>
              <Btn variant="purple" onClick={save} testid="apikey-save-btn">保存 Save Key</Btn>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
